export default __webpack_public_path__ + "static/media/documents.07547075.svg";